import { RadioBandwidth, RadioSpreadFactor } from "@somewear/api/src/proto/command_public_proto_pb";
import {
	enableableField,
	MeshDataRateIds,
	optionalBoolSchema,
	protoToZodEnum,
	RadioFrequencyIds,
	TrackingIntervalIds,
} from "@somewear/model";
import { z } from "zod";

// The defaults of the workspace default settings.
export const DEFAULT_WORKSPACE_SETTINGS_VALUES = {
	trackingInterval: TrackingIntervalIds.ATAK30,
	radioChannel: RadioFrequencyIds.AMERICAS1,
	meshDataRate: MeshDataRateIds.Low,
	backhaul: true,
	altitude: false,
	speedAndCourse: false,
};

export const workspaceDefaultsFieldsSchema = z.object({
	backhaul: enableableField(z.boolean().default(DEFAULT_WORKSPACE_SETTINGS_VALUES.backhaul)),
	altitude: enableableField(z.boolean().default(DEFAULT_WORKSPACE_SETTINGS_VALUES.altitude)),
	speedAndCourse: enableableField(
		z.boolean().default(DEFAULT_WORKSPACE_SETTINGS_VALUES.speedAndCourse),
	),
	trackingInterval: enableableField(
		z
			.nativeEnum(TrackingIntervalIds)
			.default(DEFAULT_WORKSPACE_SETTINGS_VALUES.trackingInterval),
	),
	radioChannel: enableableField(
		z.nativeEnum(RadioFrequencyIds).default(DEFAULT_WORKSPACE_SETTINGS_VALUES.radioChannel),
	),
	meshDataRate: enableableField(
		z.nativeEnum(MeshDataRateIds).default(DEFAULT_WORKSPACE_SETTINGS_VALUES.meshDataRate),
	),
});

export const workspaceDefaultsSchema = workspaceDefaultsFieldsSchema.extend({
	workspaceId: z.string(),
});

export const baseWorkspaceDeviceDefaultsRequestSchema = z.object({
	// Optional Bools
	backhaul: optionalBoolSchema,
	altitude: optionalBoolSchema,
	speedAndCourse: optionalBoolSchema,
	// Tracking Interval = trackingInterval + gpsInterval
	trackingInterval: z.number(),
	gpsInterval: z.number(),
	// Radio Channel = lowSpeedFrequency + highSpeedFrequency
	lowSpeedFrequency: z.number(),
	highSpeedFrequency: z.number(),
	// Radio Data Rate = bandwidth + spreadFactor
	bandwidth: protoToZodEnum(RadioBandwidth),
	spreadFactor: protoToZodEnum(RadioSpreadFactor),
});

export const workspaceDefaultsRequestSchema = baseWorkspaceDeviceDefaultsRequestSchema.extend({
	// Request settings
	workspaceId: z.string(),
});

export type BaseWorkspaceDefaultsRequestSchema = z.infer<
	typeof baseWorkspaceDeviceDefaultsRequestSchema
>;
export type WorkspaceDefaultsSchema = z.infer<typeof workspaceDefaultsSchema>;
export type WorkspaceDefaultsFieldsSchema = z.infer<typeof workspaceDefaultsFieldsSchema>;
export type WorkspaceDefaultsRequestSchema = z.infer<typeof workspaceDefaultsRequestSchema>;
export function isWorkspaceDeviceDefaultsField(
	key: string,
): key is keyof WorkspaceDefaultsFieldsSchema {
	return key in workspaceDefaultsFieldsSchema.shape;
}
